import auth from "./auth.reducer";
import config from "./config.reducer";

const rootReducer = {
	auth,
	config,
};

export default rootReducer;
